var _line, _line2, _polyline, _line3, _polyline2, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 64,
    y1: 21,
    x2: 0,
    y2: 21
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 0,
    y1: 43,
    x2: 64,
    y2: 43
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "39,8 32,1 25,8 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 32,
    y1: 1,
    x2: 32,
    y2: 21
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "25,56 32,63 39,56 "
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 32,
    y1: 63,
    x2: 32,
    y2: 43
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandVertical);
export default __webpack_public_path__ + "static/media/expand_vertical.ee54c7cfbe3a3d3782529cfd2b64d3e5.svg";
export { ForwardRef as ReactComponent };